import React from "react";
import cover from "../image/cover.jpg";
import logo from "../image/SVG/logo.svg";

interface TabHomeProps {
  selectTabRead: any;
}

const TabHome = (props: TabHomeProps) => {
  //Displays the title and the 'read' link

  return (
    <div className="home">
      <div className="homeCover">
        <img src={cover} alt="Electronic Sun cover" />
      </div>

      <div className="menu">
        <div className="title">
          <img src={logo} alt="electronic sun" />
          <h3>octav codrea</h3>
        </div>

        <div className="links">
          <h3 onClick={() => props.selectTabRead()}>read</h3>
        </div>
      </div>
    </div>
  );
};

export default TabHome;
